import { FC, PropsWithChildren } from 'react'

import { useIsSmallDesktop } from '../../utils'
import { Button } from '../Button'
import { Tooltip } from '../Tooltip'
import * as S from './Frame.styles'
import { FrameButtonProps } from './Frame.types'

export const FrameButton: FC<PropsWithChildren<FrameButtonProps>> = ({
  onClick,
  icon,
  buttonText,
  shouldFrameButton,
  children,
  customButtonComponent,
  ...buttonProps
}) => {
  const isSmallDesktopOrMobile = useIsSmallDesktop()

  const buttonContent = () =>
    isSmallDesktopOrMobile && shouldFrameButton ? (
      <Tooltip content={buttonText} placement="top">
        <S.ButtonContent>{icon}</S.ButtonContent>
      </Tooltip>
    ) : (
      <S.ButtonContent>
        {icon}
        {buttonText}
        {children}
      </S.ButtonContent>
    )

  const ButtonComponent = !isSmallDesktopOrMobile
    ? customButtonComponent || Button.Flat
    : Button.Flat

  return (
    <ButtonComponent onClick={onClick} {...buttonProps}>
      {buttonContent()}
    </ButtonComponent>
  )
}
